import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4 text-center">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mb-6">
        <i className="ri-error-warning-line text-3xl text-foreground-500"></i>
      </div>
      <h1 className="text-4xl md:text-6xl font-bold font-heading text-foreground-100 mb-3">404</h1>
      <p className="text-base text-foreground-400 mb-8">抱歉，您访问的页面不存在</p>
      <Link
        to="/"
        className="px-6 py-2.5 bg-accent-500 hover:bg-accent-600 text-background-950 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-home-4-line mr-2"></i>
        返回首页
      </Link>
    </div>
  );
}